import { Control, Controller } from "react-hook-form";
import { TextInput } from "../../components/form";
import { TextArea } from "../../components/form/TextArea";
import { ToggleSwitch } from "../../components/form/ToggleSwitch";
import { HorizontalDivider } from "../../components/HorizontalDivider";
import { NotificationPreview } from "../../components/NotificationPreview";
import { PushNotificationFormValues } from "./PushNotificationForm.Types";

interface PushNotificationFormStep2Props {
  control: Control<PushNotificationFormValues>;
  formValues: PushNotificationFormValues;
  goBack: () => void;
}

const PushNotificationFormStep2 = ({
  control,
  formValues,
  goBack,
}: PushNotificationFormStep2Props) => {
  return (
    <div id="step-2" className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <div className="flex rounded-md border border-gray-200 bg-white shadow-md dark:border-gray-700 dark:bg-gray-800 flex-col max-h-screen">
          <NotificationPreview
            title={formValues.title}
            body={formValues.body}
          />
        </div>
        <div className="flex flex-col max-h-screen min-h-[30rem] overflow-y-auto justify-between">
          <div>
            <Controller
              name="title"
              control={control}
              rules={{
                required: "Title is required",
              }}
              render={({ field, fieldState: { error } }) => {
                const { name, value, onBlur, disabled, onChange } = field;
                return (
                  <TextInput
                    name={name}
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                    disabled={disabled}
                    required
                    label="Title"
                    placeholder="Title"
                    errorText={error?.message}
                  />
                );
              }}
            />

            <Controller
              name="body"
              control={control}
              rules={{
                required: "Body Text is required",
              }}
              render={({ field, fieldState: { error } }) => {
                const { name, value, onBlur, disabled, onChange } = field;
                return (
                  <TextArea
                    name={name}
                    value={value}
                    onBlur={onBlur}
                    disabled={disabled}
                    onChange={onChange}
                    required
                    placeholder="Body Text"
                    label="Body Text"
                    errorText={error?.message}
                  />
                );
              }}
            />

            <HorizontalDivider />

            <Controller
              name="includeUrl"
              control={control}
              render={({ field, fieldState: { error } }) => {
                const { name, value, onChange } = field;
                return (
                  <ToggleSwitch
                    name={name}
                    onChange={onChange}
                    label="Include URL"
                    selected={value}
                  />
                );
              }}
            />
            {formValues.includeUrl && (
              <>
                <Controller
                  name="buttonLabel"
                  control={control}
                  rules={{
                    required: "Button label is required",
                    minLength: {
                      value: 2,
                      message: "Button label must be at least 2 characters",
                    },
                    maxLength: {
                      value: 20,
                      message: "Button label must be at most 20 characters",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => {
                    const { name, value, onBlur, disabled, onChange } = field;
                    return (
                      <TextInput
                        name={name}
                        value={value}
                        onBlur={onBlur}
                        onChange={onChange}
                        disabled={disabled}
                        required
                        label="Button Label"
                        placeholder="Button Label (e.g. Read More)"
                        errorText={error?.message}
                      />
                    );
                  }}
                />
                <Controller
                  name="url"
                  control={control}
                  rules={{
                    required: "URL is required",
                    pattern: {
                      value: /^(http|https):\/\/[^ "]+$/,
                      message: "URL is not valid",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => {
                    const { name, value, onBlur, disabled, onChange } = field;
                    return (
                      <TextInput
                        name={name}
                        value={value}
                        onBlur={onBlur}
                        onChange={onChange}
                        disabled={disabled}
                        required
                        label="URL"
                        placeholder="https://example.com"
                        errorText={error?.message}
                      />
                    );
                  }}
                />
              </>
            )}
          </div>

          <div className="grid grid-cols-2 gap-4 ">
            <button
              type="button"
              onClick={goBack}
              className="text-brand bg-white border-2 border-brand focus:outline-none font-medium rounded-md text-md px-5 py-2.5 me-2 mb-2 w-full"
            >
              Back
            </button>

            <button
              name="next"
              type="submit"
              className="focus:outline-none text-white bg-brand font-medium rounded-md text-md px-5 py-2.5 me-2 mb-2 w-full"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PushNotificationFormStep2;
